export default {
    namespaced: true,
    state: {
        fileList:[],
        outputDirectory:''
    },
    mutations: {
        _storeFile(state,file){
            state.fileList = [...state.fileList,file]
        },
        _updateOutput(state,path){
            state.outputDirectory = path
        }
    },
    actions: {
        storeFile (store,payload) {
            store.commit('_storeFile',payload)
        },
        updateOutput(store,payload){
            store.commit('_updateOutput',payload.path)
        }
    },
    getters: {
        getFileList(state){
            return state.fileList;
        },
        getOutputDirectory(state){
            return state.outputDirectory;
        }
    }
}